import { useDispatch } from 'react-redux'
import React, { useEffect, useRef, useState } from 'react';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import { HiDotsHorizontal } from "react-icons/hi";
import { FaCalendarDay } from "react-icons/fa";

import { CustomLoader } from '../../../services/Reducer'
import Edit from '../Fee_Collection/Edit.js'
import Delete from '../../../components/Delete.js';
import apiClient from '../../../api/apiClient.js';
import { RiFileExcel2Line } from 'react-icons/ri';
import AFFilter from './Filter.js';
import authServices from '../../../services/AuthServices.js';
import { TfiReload } from 'react-icons/tfi';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const FeeCollectionTable = () => {

  const [LogicalFlag, setLogicalFlag] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const toggleModal = () => {
    setShowModal(!showModal);
  };


  //***************************************  this is for Edit modal *************************************************

  const [editModal, seteditModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const toggleeditModal = (invoiceId) => {
    setSelectedInvoice(invoiceId);
    seteditModal(!editModal);
  };


  //**************************** GetAll Data Fetch ka function *******************************************************

  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const loader = (display) => { dispatch(CustomLoader(display)) }

  const [Records, setRecords] = useState([]);

  const [currentPage, setCurrentPage] = useState(0); // Current page
  const [totalPages, setTotalPages] = useState(1); // Total pages
  const itemsPerPage = 8; // Number of items per page

  const token = authServices.getToken();
  const fetchRecords = async (page) => {

    try {

      loader('enable');
      const response = await apiClient.get(`/api/admin/fee_collection/getAll?pageNumber=${page}&pageSize=${itemsPerPage}`, {

        headers: {
          'access_token': token,
        }
      });
      if (response.data.Status === "SUCCESS") {

        setRecords(response.data.data.records);
        setTotalPages(response.data.data.totalPages);
      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }

    finally {
      loader('disable');

    }

  };

  // Date Picker useEffect
  useEffect(() => {
    loader('disable');

    if (inputRef.current) {
      const fp = flatpickr(inputRef.current, {
        mode: "range",
        onChange: (selectedDates) => {
          if (selectedDates.length === 2) {
            setSelectedDate(selectedDates); // Set the selected date range

            setAFFromDate(null)
            setAFToDate(null)
            setLogicalFlag(true);
          }
        },
      });

      return () => {
        fp.destroy();
      };
    }
  }, []);


  // Pagination handlers
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage); // Update page
  };


  // Pagination component
  const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const pages = [];

    // Add first 2 pages
    for (let i = 0; i < Math.min(2, totalPages); i++) {
      pages.push(i);
    }

    // Add the current page if it's between first 2 and last 2 pages
    if (currentPage > 1 && currentPage < totalPages - 2) {
      pages.push(currentPage);
    }

    // Add last 2 pages
    for (let i = Math.max(totalPages - 2, 2); i < totalPages; i++) {
      pages.push(i);
    }


    // Previous button condition
    const previousPage = () => {
      if (currentPage > 0) {
        onPageChange(currentPage - 1);
      }
    };

    // Next button condition
    const nextPage = () => {
      if (currentPage < totalPages - 1) {
        onPageChange(currentPage + 1);
      }
    };

    // pagination Buttons Next & Previous
    return (
      <nav>
        <ul className="pagination">

          {/* Previous Button */}
          <li className={`page-item ${currentPage === 0 ? 'disabled' : ''}`}>
            <button onClick={previousPage} className="page-link">
              Previous
            </button>
          </li>

          {pages.map((page) => (
            <li key={page} className={`page-item ${page === currentPage ? 'active' : ''}`}>
              <button onClick={() => onPageChange(page)} className="page-link">
                {page + 1}
              </button>
            </li>
          ))}

          {/* Next Button */}
          <li className={`page-item ${currentPage === totalPages - 1 ? 'disabled' : ''}`}>
            <button onClick={nextPage} className="page-link">
              Next
            </button>
          </li>
        </ul>
      </nav>
    );
  };


  //************************************************  flatpickr code Date filter  *************************************************


  const [selectedDate, setSelectedDate] = useState([]);

  const [AFFromDate, setAFFromDate] = useState(null);
  const [AFToDate, setAFToDate] = useState(null);

  const formatDate = (date) => {

    if (!date) return '';

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;

  };

  const Flatpickr_Filter = async (page) => {

    if (LogicalFlag) {
      page = 0;
      setCurrentPage(0);
    }

    const formattedFromDate = formatDate(new Date(selectedDate[0])),
      formattedToDate = formatDate(new Date(selectedDate[1]));


    try {
      setRecords([]);

      loader('enable');

      const response = await apiClient.get(`/api/admin/fee_collection/RegsDateRangePagedWithPagination?fromDate=${formattedFromDate}&toDate=${formattedToDate}&pageNumber=${page}&pageSize=${itemsPerPage}`
        , {

          headers: {
            'access_token': token,
          }
        });

      if (response.data.Status === "SUCCESS") {

        setRecords(response.data.data.records);
        setTotalPages(response.data.data.totalPages);
      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }

    finally {
      setLogicalFlag(false);
      loader('disable');
    }

  };



  // **********************************************************************************************************************************
  // Delete List Records


  const [openModal, setOpenModal] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);

  const handleDeleteClick = (invoiceId) => {
    setSelectedInvoiceId(invoiceId);
    setOpenModal(true); // Open the modal when delete is clicked
  };


  const handleConfirmDelete = async (invoiceId) => {
    try {
      loader('enable');
      const response = await apiClient.delete(`/api/admin/fee_collection/${selectedInvoiceId}`, {

        headers: {
          'access_token': token,
        }
      });
      if (response.data.Status === "SUCCESS") {

      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      fetchRecords(currentPage);
      loader('disable');
      setOpenModal(false);
    }
  };


  const handleCloseModal = () => {
    setOpenModal(false); // Close the modal if user cancels
  };

  // Excel File Downlode  ***********************************************************************************************************

  const ExcelFileDownload = async () => {
    try {

      // Check if both dates are selected
      if (!selectedDate[0] || !selectedDate[1]) {
        toast.error('Please select Date Range');
        return;
      }

      const formattedFromDate = formatDate(new Date(selectedDate[0])),
        formattedToDate = formatDate(new Date(selectedDate[1]));

      loader('enable');

      const response = await apiClient.get(`/api/admin/fee_collection/downloadExcel?fromDate=${formattedFromDate}&toDate=${formattedToDate}`, {
        responseType: 'blob'
        ,
        headers: {
          'access_token': token,
        }
      });
      // if (response.data.Status === "SUCCESS") {

      // Create a link to download the file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      // Set the file name you want to download as
      link.setAttribute('download', 'fee_collection.xlsx'); // Change the file name if needed
      document.body.appendChild(link);
      link.click();

      // Clean up the link element
      link.remove();

      // }
      // else {
      //   console.log(response.data.message)
      // }
    } catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      loader('disable');
    }
  };



  //*************************************  This is for Advance filter **************************************************

  const [FilterModal, setFilterModal] = useState(false);

  const [selectedOption, setselectedOption] = useState(null);
  const [inputValue, setinputValue] = useState(null);
  const [CheckBoxValue, setCheckBoxValue] = useState(null);


  const toggleFilterModal = () => {
    setFilterModal(!FilterModal);
  };

  const handleSendDataToParent = (fromDate, toDate, column, value, selectedCheckboxValue) => {
    setAFFromDate(fromDate)
    setAFToDate(toDate)
    setselectedOption(column)
    setinputValue(value)
    setCheckBoxValue(selectedCheckboxValue)
    setTotalPages(0);
    setSelectedDate([]);
    setLogicalFlag(true);

  };


  const applyFilter = async (page) => {

    if (LogicalFlag) {
      page = 0;
      setCurrentPage(0);
    }

    try {
      setTotalPages(0);
      setRecords([]);
      loader('enable');

      const pageNumber = page;
      const pageSize = itemsPerPage;

      const fromDate = AFFromDate;
      const toDate = AFToDate;
      const column = selectedOption;
      const value = inputValue;
      const status = CheckBoxValue;

      const response = await apiClient.get(`/api/admin/fee_collection/filter`, {
        params: {
          pageNumber,
          pageSize,
          fromDate,
          toDate,
          column,
          value,
          status,
        },

        headers: {
          'access_token': token,
        }
      });

      if (response.data.Status == "SUCCESS") {

        setRecords(response.data.data.records);
        setTotalPages(response.data.data.totalPages);
        // console.log("success",response.data.message)

      }
      else {
        console.log("fail", response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      setLogicalFlag(false);
      loader('disable');
    }

  };
  // ************************************************************************************************************************************

  useEffect(() => {

    if (selectedDate[0] && selectedDate[1]) {
      Flatpickr_Filter(currentPage);

    }
    else if (AFFromDate && AFToDate) {
      applyFilter(currentPage);

    }
    else {
      fetchRecords(currentPage);

    }
  }, [currentPage, AFFromDate, AFToDate, selectedDate]);


  // **********************************************************************************************************************

  const displayedData = Records;

  // *************************************************  This For CheckBox  **********************************************************

  const [selectedItems, setSelectedItems] = useState([]);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allIds = displayedData.map(invoice => invoice.id);
      setSelectedItems(allIds);
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectItem = (event, id) => {
    if (event.target.checked) {
      setSelectedItems([...selectedItems, id]);
    } else {
      setSelectedItems(selectedItems.filter(item => item !== id));
    }
  };

  // Reset filter and fetch original data
  const resetFilter = () => {
    setSelectedDate([]);
    fetchRecords(0);
    setCurrentPage(0);
    setAFFromDate(null)
    setAFToDate(null)

    // Reset flatpickr calendar dates
    if (inputRef.current && inputRef.current._flatpickr) {
      inputRef.current._flatpickr.clear();
    }
  };

  return (

    <>
      <Edit edit={editModal} toggle_Edit={toggleeditModal} invoiceId={selectedInvoice}
        refreshData={fetchRecords} AddcurrentPage={currentPage} />

      <AFFilter
        Filter={FilterModal}
        toggle_Filter={toggleFilterModal}
        SendDataToParent={handleSendDataToParent}

      />
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <div className="mb-4">


                </div>
                <div className="d-flex align-items-center gap-1 mb-4">
                  <div className="input-group datepicker-range">
                    <input
                      ref={inputRef}
                      className="form-control flatpickr-input input"
                      type="text"
                      value={
                        selectedDate.length === 2 && selectedDate[0] && selectedDate[1]
                          ? `${formatDate(selectedDate[0])} - ${formatDate(selectedDate[1])}`
                          : "" // Empty input initially
                      }
                      onChange={(e) => {
                        const dateRange = e.target.value.split(" - ");
                        const startDate = dateRange[0] ? new Date(dateRange[0].split('-').reverse().join('-')) : null;
                        const endDate = dateRange[1] ? new Date(dateRange[1].split('-').reverse().join('-')) : null;

                        setSelectedDate([startDate, endDate]);

                      }}
                      placeholder="Filter By Registration Date"
                    />

                    <button className="input-group-text" id="date1" onClick={resetFilter}>
                      <TfiReload />
                    </button>

                  </div>
                  <div className="dropdown">
                    <a
                      className="btn btn-link text-muted py-1 font-size-16 shadow-none dropdown-toggle"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      < HiDotsHorizontal />
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end">

                      <li>
                        <a className="dropdown-item" onClick={() => toggleFilterModal()}>

                          Filter
                        </a>
                      </li>

                      <li>
                        <button className="dropdown-item" onClick={ExcelFileDownload}>
                          <RiFileExcel2Line
                            style={{
                              fontSize: '20px',
                              marginLeft: '-0.50vw',
                              marginRight: '0.50vw',
                              marginTop: '-0.10vw',
                            }}
                          />
                          Excel File Download
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* end row */}
              <div className="table-responsive ">
                <table
                  className="table table-bordered align-middle datatable dt-responsive table-check nowrap text-center"
                  style={{
                    borderCollapse: "collapse",
                    borderSpacing: "0 8px",
                    width: "100%"
                  }}
                >
                  <thead className='table-light'>
                    <tr className="bg-transparent">
                      {/* <th style={{ width: 5 }}>
                        <div className="form-check font-size-16">
                          <input
                            type="checkbox"
                            name="check"
                            className="form-check-input"
                            id="checkAll"
                            onChange={handleSelectAll}
                            checked={selectedItems.length === displayedData.length}
                          />
                          <label className="form-check-label" htmlFor="checkAll" />
                        </div>
                      </th> */}
                      {/* <th style={{ width: 100 }}>_ID_</th> */}
                      <th style={{ width: 100 }}>IMO&nbsp;Number</th>
                      <th style={{ width: 100 }}>Register&nbsp;Date</th>
                      <th style={{ width: 100 }}>Port&nbsp;Of&nbsp;Registry</th>
                      <th style={{ width: 100 }}>Official&nbsp;Number</th>
                      <th style={{ width: 100 }}>Arrival&nbsp;Date</th>
                      <th style={{ width: 100 }}>Commencement&nbsp;Date</th>
                      <th style={{ width: 100 }}>Departure&nbsp;Date</th>
                      <th style={{ width: 100 }}>Rate</th>
                      <th style={{ width: 100 }}>Quantity</th>
                      <th style={{ width: 100 }}>Total</th>
                      <th style={{ width: 100 }}>Penalty&nbsp;Days</th>
                      <th style={{ width: 100 }}>Penalty&nbsp;Total</th>
                      <th style={{ width: 100 }}>Final&nbsp;Amount</th>
                      <th style={{ width: 100 }}>Payment&nbsp;Mode</th>
                      <th style={{ width: 100 }}>Payment&nbsp;Status</th>
                      <th style={{ width: 100 }}>Port&nbsp;Type</th>
                      <th style={{ width: 100 }}>Fee&nbsp;Type</th>
                      <th style={{ width: 100 }}>Commodity</th>
                      <th style={{ width: 100 }}>Vessel</th>
                      <th style={{ width: 100 }}>Operator</th>
                      <th style={{ width: 100 }}>Company&nbsp;Name</th>
                      <th style={{ width: 100 }}>Financial&nbsp;Year</th>
                      <th style={{ width: 100 }}>Bill&nbsp;Type</th>
                      <th style={{ width: 100 }}>Exempted</th>
                      <th style={{ width: 100 }}>Sub&nbsp;Commodity</th>
                      <th style={{ width: 100 }}>Sub&nbsp;Sub&nbsp;Commodity</th>

                      {/* <th style={{ width: 100 }}>Action</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {displayedData.length > 0 ? (
                      <>
                        {displayedData.map(invoice => (
                          <tr key={invoice.id}>
                            {/* <td>
                              <div className="form-check font-size-16">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id={`check-${invoice.id}`}
                                  checked={selectedItems.includes(invoice.id)}
                                  onChange={(e) => handleSelectItem(e, invoice.id)}
                                />
                                <label className="form-check-label" htmlFor={`check-${invoice.id}`} />
                              </div>
                            </td> */}
                            {/* <td>
                            <a
                              className="text-body fw-medium"
                            >{invoice.id}
                            </a>
                          </td> */}
                            <td>{invoice?.imoNumber || '--'}</td>
                            <td>{invoice?.regsDate || '--'}</td>
                            <td>{invoice?.portOfRegistry || '--'}</td>
                            <td>{invoice?.officialNumber || '--'}</td>
                            <td>{invoice?.arrivalDate || '--'}</td>
                            <td>{invoice?.commencementDate || '--'}</td>
                            <td>{invoice?.departureDate || '--'}</td>
                            <td>{invoice?.rate || '--'}</td>
                            <td>{invoice?.quantity || '--'}</td>
                            <td>{invoice?.total || '--'}</td>
                            <td>{invoice?.penaltyDays || '--'}</td>
                            <td>{invoice?.penaltyTotal || '--'}</td>
                            <td>{invoice?.finalAmount || '--'}</td>
                            <td>{invoice?.paymentMode || '--'}</td>

                            <td>{invoice?.paymentStatus || '--'}</td>
                            <td>{invoice?.portTypeId?.portType || '--'}</td>
                            <td>{invoice?.feeTypeId?.feeType || '--'}</td>
                            <td>
                              <details>
                                <summary>View</summary>
                                {invoice?.commodityId?.commodity || '--'}
                              </details>
                            </td>

                            <td>{invoice?.vesselId?.name || '--'}</td>
                            <td>{invoice?.operatorId?.name || '--'}</td>

                            <td>{invoice?.companyName || '--'}</td>
                            <td>{invoice?.financialYear || '--'}</td>
                            <td>{invoice?.billType || '--'}</td>
                            <td>{invoice?.exempted === true ? 'Yes' : 'No' || '--'}</td>

                            <td>
                              <details>
                                <summary style={{ cursor: 'pointer', }}>View</summary>
                                <div style={{ paddingTop: '8px' }}>
                                  <p>{invoice?.subCommodityId?.subCommodity || '--'}</p>
                                </div>
                              </details>
                            </td>

                            <td>
                              <details>
                                <summary style={{ cursor: 'pointer', }}>View</summary>
                                <div style={{ paddingTop: '8px' }}>
                                  <p>{invoice?.subSubCommodityId?.subSubCommodity || '--'}</p>
                                </div>
                              </details>
                            </td>

                            {/* <td>
                              <div className="dropdown">
                                <button
                                  className="btn btn-link font-size-16 shadow-none py-0 text-muted dropdown-toggle"
                                  type="button"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  < HiDotsHorizontal />
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end">
                                  <li>

                                    <button
                                      onClick={() => toggleeditModal(invoice.id)}
                                      type="button"
                                      className="btn waves-effect waves-light dropdown-item"
                                    >

                                      <i className="dropdown-item" /> Edit
                                    </button>

                                  </li>

                                  <li>
                                    <button className="btn waves-effect waves-light dropdown-item"
                                      onClick={() => handleDeleteClick(invoice.id)}
                                    >
                                      Delete
                                    </button>
                                    <Delete
                                      open={openModal}
                                      handleClose={handleCloseModal}
                                      handleConfirm={handleConfirmDelete}
                                      message="Are you sure you want to delete this invoice ?"
                                    />
                                  </li>
                                </ul>
                              </div>
                            </td> */}
                          </tr>
                        ))}
                      </>
                    ) : (
                      <tr>
                        <td colSpan={19}>
                          <p className="text-center" >Record Not Found</p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {/* end table responsive */}

              <div className='d-flex flex-row justify-content-end'>
                Showing {currentPage + 1} In to {totalPages} Entries
              </div>

              {/* Pagination */}

              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />

            </div>

            {/* end card body */}
          </div>
          {/* end card */}
        </div>
        {/* end col */}
      </div>
    </>

  );
};

export default FeeCollectionTable;
